import React, { useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import block from 'bem-cn';
import { Redirect } from 'react-router-dom';

import Spinner from 'components/Spinner/view/desktop';
import Modal from 'components/ModalProvider/Modal/Modal';

import FilterBlock from './FilterBlock';
import Table from './Table/Table';
import CashbackActionModal from './CashbackActionModal/CashbackActionModal';

import './CashbackHistory.scss';

const b = block('cashback-history-desktop');

const CashbackHistory = ({ isMobile }) => {
  const { actionProcessing } = useSelector(state => state.reports, shallowEqual);
  const { isCashbackActive } = useSelector(state => state.auth, shallowEqual);

  const [count, setCount] = useState(10);
  const [page, setPage] = useState(0);
  const [cashbackActionModal, setCashbackActionModal] = useState(null);

  const onItemsOnPageChanged = newItemsOnPage => {
    setCount(newItemsOnPage);
    setPage(0);
  };

  if (!isCashbackActive) {
    return <Redirect to="/" />;
  }

  return (
    <div className={b({ isMobile })}>
      <Spinner isLoading={actionProcessing} />
      {cashbackActionModal && (
        <Modal
          closeFunction={() => setCashbackActionModal(null)}
          content={
            <CashbackActionModal type={cashbackActionModal} closeFunction={() => setCashbackActionModal(null)} />
          }
        />
      )}
      <FilterBlock
        count={count}
        currentPage={page}
        onPageClick={setPage}
        // isMobile={isMobile}
        setCashbackActionModal={setCashbackActionModal}
      />
      <Table
        currentPage={page}
        onPageClick={setPage}
        onItemsOnPageChanged={onItemsOnPageChanged}
        // isMobile={isMobile}
      />
    </div>
  );
};

export default CashbackHistory;
